<div>
  <div class="page-title">
    <h4 translate>HOME_PAGE.SHOP</h4>
  </div>

  <div class="shop-page">
    <div class="card">
      <div class="desktop-grid" [class.arebic-content]="textDirection === 'rtl'">
        <section class="partner-section">
          <div class="partner-grid">
            @for (item of shopList; track item.brandName) {
              <a
                class="partner-card-link"
                [href]="item.url"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div class="partner-card">
                  <img
                    [src]="item?.merchantFeaturedUrl"
                    alt="Partner Logo"
                    class="partner-feature-logo"
                    (error)="handleImageError($event)"
                  />
                  <div class="partner-info">
                    <img [src]="item?.logoUrl" alt="logoUrl" (error)="handleImageError($event)" />
                    <div class="store-details">
                      <span class="name">
                        {{
                          textDirection === 'rtl' ? item?.businessNameArabic : item.businessName
                        }} </span
                      ><br />
                      <span class="type">{{ item?.businessType }}</span>
                    </div>
                  </div>
                </div>
              </a>
            } @empty {}
          </div>

          @if (showLoadMore) {
            <div class="footer">
              <button class="btn btn-outline" translate (click)="loadMoreShops()">
                BUTTON.SEE_MORE
              </button>
            </div>
          }
        </section>
      </div>
    </div>
    <div class="lets-shopping" [class.arebic-content]="textDirection === 'rtl'">
      <div class="col-5 text-title">
        <div class="shop-title">
          <h4 translate>SHOP_PAGE.SHOP_TITLE</h4>
          <p translate>SHOP_PAGE.SHOP_DESC</p>
        </div>
      </div>
      <div class="col-5 img-container">
        <div class="shop-img desktop">
          <img src="assets/images/shops-items-img.svg" alt="shop-img" />
        </div>
        <div class="shop-img mobile">
          <img src="assets/images/shops-mob-img.svg" alt="shop-img" />
        </div>
      </div>
    </div>
  </div>
</div>
